import { atom } from "recoil";

export const companyUniqueId = atom({
  key: "companyUniqueId",
  default: "",
});
export const companyId = atom({
  key: "companyId",
  default: "",
});
export const isCompanyActive = atom({
  key: "isCompanyActive",
  default: false,
});
export const showSearchExistingConsentBtn = atom({
  key: "showSearchExistingConsentBtn",
  default: false,
});
